export default function CountNumbers() {
    this.init = () => {
        initCounterObserver();
        // target.toLocaleString("en-US"); // 1,000
    };

    function countNumber(counterElement) {
        const target = parseInt(counterElement.getAttribute("data-target").replace(/\./g, ""), 10);
        
        const increment = Math.ceil(target / 100);
        let currentValue = 0;

        const updateCounter = () => {
            currentValue += increment;
            if (currentValue >= target) {
                counterElement.textContent = target.toLocaleString();
            } else {
                counterElement.textContent = currentValue.toLocaleString();
                requestAnimationFrame(updateCounter);
            }
        };

        updateCounter();
    }

    function initCounterObserver() {
        const counters = document.querySelectorAll(".counter");
        const section = document.querySelector("#counter-section");

        if (!section) return;

        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        counters.forEach(counter => countNumber(counter));
                        observer.disconnect();
                    }
                });
            },
            { threshold: 0.5 }
        );

        observer.observe(section);
    }
}
